import { Injectable, InjectionToken } from '@angular/core';
import { ContentProvider } from './content.provider';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export const CONTENT_FRAGMENT_PROVIDER = new InjectionToken<ContentFragmentProvider>('Content Fragment Provider');

@Injectable()
export class ContentFragmentProvider {

  fragments: Observable<any>;

  constructor(contentProvider: ContentProvider) {
    this.fragments = contentProvider.get<any>('contentFragments')
                      .pipe(
                        map(p => p != null ? p.fragments : null),
                        shareReplay(1)
                      );
  }

}